/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { Trans } from "app/utils";
import React from "react";
// @ts-ignore
import StackGrid from "react-stack-grid";
import getCustomImageLibrary from "./getCustomImageLibrary";

type CustomImageLibraryProps = {
  inline?: boolean;
  organizationName: string;
  onSelectImage: (image: any) => void;
};

const CustomImageLibrary: React.FC<CustomImageLibraryProps> = ({
  inline,
  organizationName,
  onSelectImage
}) => {
  const images = getCustomImageLibrary(organizationName);

  return (
    <div className={`Unsplash--Search ${inline && "Unsplash--Search-inline"}`}>
      <div className="Unsplash--Search__Title">
        <h4>
          <Trans>Library</Trans>
        </h4>
      </div>
      <div className="images-results">
        <StackGrid columWidth={140} monitorImagesLoaded>
          {images.map(image => (
            <div
              tabIndex={0}
              key={image.id}
              className="image-result"
              onClick={() => { onSelectImage(image); }}
              onKeyDown={e => { if (e.key === "Enter") onSelectImage(image); }}
            >
              <img className="image" src={image.urls.regular} alt={image.alt_description} />
            </div>
          ))}
        </StackGrid>
      </div>
    </div>
  );
};

export default CustomImageLibrary;
